import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import ConfirmButton from "@saleor/components/ConfirmButton";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    cancelButton: {
      backgroundColor: "#F4F4F4",
      color: theme.palette.text.primary,
      height: 39,
      textTransform: "none",
      width: 136
    },
    closeButton: {
      color: theme.palette.text.secondary,
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1)
    },

    confirmButton: {
      "& span": {
        color: "#ffffff"
      },
      "&.outlined": {
        "&:hover": {
          backgroundColor: "#ffffff"
        },
        backgroundColor: "#ffffff",
        border: "2px solid #0030FF"
      },
      "&.outlined span": {
        color: "#0030FF !important"
      },
      "&:hover": {
        backgroundColor: "#0030FF"
      },
      "&:hover span": {
        color: "#ffffff"
      },
      "&:last-child": {
        marginLeft: "10px"
      },

      backgroundColor: "#0030FF",
      color: "#ffffff",
      height: 39,

      textTransform: "none",
      width: 136
    },
    content: {
      color: theme.palette.text.secondary,
      fontSize: "14px",
      padding: theme.spacing(1)
    },
    dialogPaper: {
      backgroundColor: "white",
      borderRadius: 8,
      overflow: "hidden",
      position: "relative",
      textAlign: "center",
      width: 468
    },
    title: {
      fontSize: "20px",
      fontWeight: 700,
      marginBottom: theme.spacing(1)
    }
  }),
  { name: "2FAToggleSwitchDialog" }
);

interface CustomDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isMfaEnabled: boolean; // Add this prop
}

const MfaToggleSwitchDialog: React.FC<CustomDialogProps> = props => {
  const { open, onClose, onConfirm, isMfaEnabled } = props;
  const classes = useStyles(props);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
    >
      <IconButton className={classes.closeButton} onClick={onClose}>
        <CloseIcon />
      </IconButton>

      <DialogTitle disableTypography>
        <Typography className={classes.title}>
          {isMfaEnabled
            ? "You are about to disable Two-Factor Authentication (2FA)."
            : "You are about to enable Two-Factor Authentication (2FA)"}
        </Typography>
      </DialogTitle>

      <Typography className={classes.content}>
        {isMfaEnabled
          ? "Once disabled, user(s) will not be required to enter an authentication code to log in."
          : "Once enabled, user(s) must enter an authentication code to log in."}
      </Typography>

      <DialogActions>
        <Button onClick={onClose} className={classes.cancelButton}>
          Discard
        </Button>
        <ConfirmButton
          transitionState="default"
          color="secondary"
          variant="contained"
          type="submit"
          className={classes.confirmButton}
          onClick={onConfirm}
        >
          {isMfaEnabled ? "Disable" : "Enable"}
        </ConfirmButton>
      </DialogActions>
    </Dialog>
  );
};

export default MfaToggleSwitchDialog;
